import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Access,
  AdminAccess,
  CreateCompany,
  CreateReasonRefusal,
  CreateUser,
  EditCompany,
  EditConfig,
  EditUser,
  Home,
  ReasonsRefusal,
  Reprocessing,
  VehicleType,
  ViewCompany,
  ViewUser,
  ViewVehicle,
} from '..';
import ResetPassword from '../../components/ResetPassword';
import { api } from '../../services/api';
import { loginFailure } from '../../store/ducks/auth/actions';
import { loginDistributorFailure } from '../../store/ducks/distributor/actions';
import CreateDistributorMapping from '../CreateDistributorMapping';
import Import from '../Import';
import ViewFreight from '../ViewFreight';
import { PrivateRoute } from '../_PrivateRoute';
import PrivacyPolicy from '../PrivacyPolicy';
import SupportPage from '../Support';
import Configurations from '../Configurations';
import deleteAccountPage from '../FormDeleteAccount';
import UsersAdmin from '../UsersAdmin';
import CreateUserAdmin from '../UsersAdmin/components/CreateUserAdmin';
import EditUserAdmin from '../UsersAdmin/components/EditUserAdmin';
import { checkAdmin } from '../../services/validation';
import { ApplicationState } from '../../store';
import CreatePrivateDriver from '../CreatePrivateDriver';
import UpdatePrivateDriver from '../UpdatePrivateDriver';
import CreatePrivateVehicleForm from '../CreatePrivateVehicle';
import UpdatePrivateVehicleForm from '../UpdatePrivateVehicle';

export default function Routes() {
  const dispatch = useDispatch();
  const token = useSelector(
    (state: ApplicationState) => state.auth.token || state.distributor.token,
  );

  api.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response.status === 401) {
        dispatch(loginFailure({}));
        dispatch(loginDistributorFailure({}));
      }
      toast.clearWaitingQueue();
      throw error;
    },
  );

  return (
    <Switch>
      <Route exact path="/login" component={Access} />
      <Route exact path="/politicas-de-privacidade" component={PrivacyPolicy} />
      <Route exact path="/support" component={SupportPage} />
      <Route exact path="/remover-conta-app" component={deleteAccountPage} />
      <Route exact path="/Reset/Password" component={ResetPassword} />
      <Route exact path="/admin/login" component={AdminAccess} />
      <PrivateRoute exact path="/home/:option" component={Home} />

      <PrivateRoute
        exact
        path="/home/vehicle-types/create"
        component={VehicleType}
      />
      <PrivateRoute
        exact
        path="/home/vehicle-types/edit"
        component={VehicleType}
      />

      <PrivateRoute
        exact
        path="/home/vehicles/view/:id"
        component={ViewVehicle}
      />

      <PrivateRoute exact path="/home/users/view/:id" component={ViewUser} />
      <PrivateRoute exact path="/home/users/create" component={CreateUser} />
      <PrivateRoute exact path="/home/users/edit/:id" component={EditUser} />
      <PrivateRoute
        exact
        path="/home/companies/view/:id"
        component={ViewCompany}
      />
      <PrivateRoute
        exact
        path="/home/companies/create"
        component={CreateCompany}
      />
      <PrivateRoute
        exact
        path="/home/companies/edit/:id"
        component={EditCompany}
      />
      <PrivateRoute
        exact
        path="/home/settings/edit/:id"
        component={EditConfig}
      />

      <PrivateRoute
        exact
        path="/home/companies/mapping/:id"
        component={CreateDistributorMapping}
      />

      <PrivateRoute
        exact
        path="/home/reasons-refusal"
        component={ReasonsRefusal}
      />

      <PrivateRoute
        exact
        path="/home/reason-refusal/create"
        component={CreateReasonRefusal}
      />
      <PrivateRoute
        exact
        path="/home/shippings/view/:id"
        component={ViewFreight}
      />

      <PrivateRoute exact path="/home/reprocessing" component={Reprocessing} />
      <PrivateRoute exact path="/home/users-admin" component={UsersAdmin} />
      <PrivateRoute
        exact
        path="/home/users-admin/edit/:id"
        component={EditUserAdmin}
      />

      <PrivateRoute
        exact
        path="/home/users-admin/create"
        component={CreateUserAdmin}
      />

      <PrivateRoute
        exact
        path="/home/configurations"
        component={Configurations}
      />

      <PrivateRoute
        exact
        path="/home/private-drivers/create"
        component={CreatePrivateDriver}
      />
      <PrivateRoute
        exact
        path="/home/private-drivers/edit"
        component={UpdatePrivateDriver}
      />
      <PrivateRoute
        exact
        path="/home/private-vehicles/create"
        component={CreatePrivateVehicleForm}
      />
      <PrivateRoute
        exact
        path="/home/private-vehicles/edit/:id"
        component={UpdatePrivateVehicleForm}
      />

      <PrivateRoute exact path="/home/import" component={Import} />
      {token ? (
        checkAdmin(token) ? (
          <Redirect from="/" to="/home/dashboard-admin" />
        ) : (
          <Redirect from="/" to="/home/dashboard" />
        )
      ) : (
        <Redirect from="/" to="/login" />
      )}
      <Redirect from="*" to="/" />
    </Switch>
  );
}
